import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "../../../util/dates/DateFormats";

export default (original: string) => {
  if (!original) return "";
  return moment(original, "MM/DD/YYYY").format(DEFAULT_DATE_FORMAT);
};
